import { ButtonOLD } from '@lmc/ui-kit'
import { CSSProperties } from 'react'

interface NextStepSectionProps {
  onNext: () => void
  label?: string
  showText?: boolean
}

const NextStepSection: React.FC<NextStepSectionProps> = ({
  onNext,
  label = 'Next Step',
  showText = true,
}) => (
  <div style={styles.container as CSSProperties}>
    <div style={styles.sectionContainer as CSSProperties}>
      <div style={styles.buttonContainer as CSSProperties}>
        {/*
       // @ts-ignore */}
        <ButtonOLD id="next-step-button" onClick={onNext} type="primary">
          {label}
        </ButtonOLD>
        {showText && (
          <div style={{ marginRight: 18, color: '#999999' }}>
            Note: You can change these settings at a later date
          </div>
        )}
      </div>
    </div>
  </div>
)

const styles = {
  container: {
    display: 'flex',
    height: '12%',
    width: '100%',
    position: 'fixed',
    bottom: 0,
    boxShadow: '0px 0px 8px rgba(34, 34, 34, 0.2)',
    background: '#FFFFFF',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  sectionContainer: {
    maxWidth: 960,
    display: 'flex',
    flex: 1,
    position: 'relative',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  buttonContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center',
  },
}

export default NextStepSection
